import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import httpService from "../../../../services/httpServices/httpServices";
import typeTransaction from "./typeTransaction";
import Pagination from "../../../partials/content/Pagination";

function AllTransaction() {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [transactionIDSearchFilter, setTransactionIDSearchFilter] = useState();
  const [currentTransactionID, setCurrentTransactionID] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [isEditReason, setIsEditReason] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  useEffect(() => {
    getAllTransactions();
  }, []);

  useEffect(() => {
    getAllTransactions();
  }, [currentPage, countItemPerPage, transactionIDSearchFilter]);

  const getAllTransactions = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllTransactions =
      await sendRequestGetAllTransactions(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllTransactions) {
      return;
    }

    setCountPage(resultSendRequestGetAllTransactions.count_page);
    setTransactions(resultSendRequestGetAllTransactions.transactions);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllTransactions = async (searchFilterQuery) => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/payment/manage/transaction/list/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const generateTagOperation = (operate) => {
    let statusTagOperate = <></>;
    switch (operate) {
      case typeTransaction.typeOperateTransaction.ADD:
        statusTagOperate = (
          <span className="badge badge-success">
            {typeTransaction.typeOperateTransactionString()[operate]}
          </span>
        );
        break;
      case typeTransaction.typeOperateTransaction.SUBTRACT:
        statusTagOperate = (
          <span className="badge badge-danger">
            {typeTransaction.typeOperateTransactionString()[operate]}
          </span>
        );
        break;
    }
    return statusTagOperate;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (transactionIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${transactionIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const generateTransactions = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره انتقال</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setTransactionIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تراکنش</td>
                <td> شماره کاربری انجام دهنده</td>
                <td>شماره کاربری</td>
                <td>نام کاربر</td>
                <td>مبلغ(تراکنش)</td>
                <td>عملیات</td>
                <td>تاریخ درج</td>
                <td>دلیل</td>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction, index) => {
                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>{helpersNumbers.toPersianNum(transaction.tran_id)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        transaction.tran_owner_user_id
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(transaction.tran_user_id)}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(transaction.user_name)}
                    </td>
                    <td>
                      <span className="letter-spacing-finance-number">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(
                            transaction.tran_amount
                          )
                        )}
                      </span>
                    </td>
                    <td>{generateTagOperation(transaction.tran_operate)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(transaction.tran_created_at)}
                    </td>
                    <td>
                      <span
                        className="btn btn-info"
                        onClick={(e) => {
                          setCurrentTransactionID(transaction.tran_id);
                          handleShowModal();
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const editReason = async () => {
    const reason = document.querySelector("#reason").value.trim();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    await sendRequestEditReason(currentTransactionID, reason);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestEditReason = async (transactionID, reason) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/payment/manage/transaction/${transactionID}/edit-reason`,
        { reason: reason },
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const showReasonTransaction = () => {
    if (!currentTransactionID) {
      return;
    }
    if (transactions.length == 0) {
      return;
    }
    const transaction = transactions.filter(
      (transaction) => transaction.tran_id == currentTransactionID
    );
    if (transaction.length == 0) {
      return;
    }
    return (
      <div>
        <p>{transaction[0].tran_reason}</p>
        <hr />
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            await editReason();
            setIsEditReason(false);
            getAllTransactions();
          }}
          className={`${isEditReason ? "" : "d-none"}`}
        >
          <div className="py-2">
            <textarea className="form-control" rows={5} id="reason" required>
              {transaction[0].tran_reason}
            </textarea>
          </div>
          <button
            className={`${isEditReason ? "" : "d-none"}  btn btn-success`}
          >
            اعمال
          </button>
        </form>

        <div>
          <span
            className={`${isEditReason && "d-none"} btn btn-success`}
            onClick={() => {
              setIsEditReason(true);
            }}
          >
            ویرایش متن دلیل
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="all-transaction" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">پیش فاکتور</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <div>
                  <Link
                    to="/finance/manage/add-transaction"
                    className="btn btn-success"
                  >
                    <span className="d-flex align-items-center">
                      <i className="fa fa-plus"></i>
                      <span className="pr-2">تراکنش جدید</span>
                    </span>
                  </Link>
                </div>
                <br />
                {transactions.length == 0 &&
                transactionIDSearchFilter == null ? (
                  <></>
                ) : (
                  generateTransactions()
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>دلیل انجام تراکنش</Modal.Title>
        </Modal.Header>
        <Modal.Body>{showReasonTransaction()}</Modal.Body>
        <Modal.Footer>
          <span className="btn btn-danger" onClick={handleCloseModal}>
            خروج
          </span>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AllTransaction;
